<div class="snackbar">
  <div class="snackbar-header">
    <div class="snackbar-text">
      <span matTooltip="{{ getStatusText() }}">{{ getStatusText() }}</span>
    </div>
    <div class="snackbar-controls">
      @if (!isExpanded) {
        <button class="btn" mat-icon-button (click)="toggleFilesVisibility()">
          <app-icon>expand_less</app-icon>
        </button>
      }
      @if (isExpanded) {
        <button class="btn" mat-icon-button (click)="toggleFilesVisibility()">
          <app-icon>expand_more</app-icon>
        </button>
      }
      <button class="btn" mat-icon-button (click)="closeSnackBar()">
        <app-icon>close</app-icon>
      </button>
    </div>
  </div>

  <div class="h-100 overflow-auto crm-scroll scroll">
    @if (isExpanded) {
      <div class="snackbar-content">
        @for (file of files; track file) {
          <div class="snackbar-file">
            <div class="file-header">
              <app-icon
                matTooltip="{{
                  file.type === 'upload' ? ('snack_bar.upload' | translate) : ('snack_bar.download' | translate)
                }}"
              >
                {{ file.type === 'upload' ? 'upload_2' : 'download_2' }}
              </app-icon>
              <span
                class="snackbar-text"
                [ngStyle]="{ 'max-width': file.status !== 'error' && file.progress < 100 ? '100px' : '250px' }"
              >
                {{ file.fileName }}
              </span>
            </div>
            @if (file.status !== 'error' && file.progress < 100) {
              <div class="progress-bar">
                <mat-progress-bar mode="determinate" [value]="file.progress"> </mat-progress-bar>
                <span>{{ file.progress }}%</span>
              </div>
            }
            @if (file.status === 'complete') {
              <app-icon style="color: green"> check_circle </app-icon>
            }
            @if (file.status === 'error') {
              <app-icon style="color: red" matTooltip="{{ file.errorType | translate }}"> error </app-icon>
            }
          </div>
        }
      </div>
    }
  </div>
</div>
